import ModalPrompt from "@/app/components/ui/Modals/Prompt";
import { useInventoryPurchaseOrderListFilterAPI } from "@/app/hooks/api_hooks/Inventory/PO/useInventoryPurchaseOrderListFilterAPI";
// import { useInventoryPurchaseOrderSearchAPI } from "@/app/hooks/api_hooks/Inventory/PO/useInventoryPurchaseOrderSearchAPI";
import { usePODelete } from "@/app/hooks/api_hooks/Inventory/PO/usePODeleteAPI";
import { useModalActions } from "@/app/hooks/ui_hooks/useModalActions";
import { useModalState } from "@/app/hooks/ui_hooks/useModalState";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useRouter } from "@/app/hooks/useRouter";
import { IInventoryState } from "@/app_redux/reducers/slices/auth/inventory_slice";
import { useEffect, useState } from "react";
import { toast } from "react-hot-toast";

export interface PODeleteModalContentProps {
  onReasonChange: (reason: string) => void;
}

const PODeleteModalContent = ({
  onReasonChange,
  reason,
  showError,
}: {
  onReasonChange: (reason: string) => void;
  reason: string;
  showError: boolean;
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newReason = e.target.value;
    onReasonChange(newReason);
  };

  return (
    <div className="p-4 bg-white rounded-[20px] flex-col justify-start items-end gap-6 inline-flex">
      <div className="justify-start items-center gap-16 inline-flex mb-20">
        <div className="flex justify-start items-center gap-1 p-2.5 w-[150px] h-[38px]">
          <span className="font-normal text-black text-xs">Reason</span>
          <span className="font-normal text-rose-600 text-xs">*</span>
        </div>
        <div className="h-9 justify-center items-center gap-2.5 flex">
          <div className="h-9 w-[300px] mt-2">
            <textarea
              rows={4}
              cols={70}
              placeholder="Add Reason...."
              className={`w-full p-2 border ${showError ? "border-red-500" : "border-gray-300"} rounded-md text-sm`}
              value={reason}
              onChange={handleChange}
            />
            {showError && <div className="text-red-500 text-xs mt-1">Reason is required.</div>}
          </div>
        </div>
      </div>
    </div>
  );
};
const PODeleteModal = () => {
  const { getRouteKey } = useRouter();
  const [reason, setReason] = useState("");
  const [showError, setShowError] = useState(false);
  const { execute: deletePO } = usePODelete();
  const modalState = useModalState("PO_DELETE_MODAL");
  const { po_id } = modalState;
  // const fetchOrderList = useInventoryPurchaseOrderSearchAPI();
  const { setInvisible } = useModalActions("PO_DELETE_MODAL");
  const { routeState } = useRouteInfo(getRouteKey("INVENTORY", "id"));
  const { purchaseOrderFilter } = routeState.state as IInventoryState;
  const fetchProductorderList = useInventoryPurchaseOrderListFilterAPI();

  useEffect(() => {
    setReason("");
    setShowError(false);
  }, [po_id]);

  const handleSave = async () => {
    if (!reason.trim()) {
      setShowError(true);
      return;
    }
    if (!po_id) {
      toast.error("PO ID is missing.");
      return;
    }
    const payload = {
      po_id: po_id,
      deletion_reason: reason,
    };
    try {
      const response = await deletePO(payload);
      
      if (response?.status) {
        setInvisible();
        toast.success("PO deleted successfully.");
        await fetchProductorderList(purchaseOrderFilter);
        setReason("");
      }
    } catch (error) {
      console.error("Delete PO error:", error);
    }
  };

  return (
    <ModalPrompt
      modalId="PO_DELETE_MODAL"
      showIcon={false}
      contentOverflow={true}
      titleIcon=""
      dialogClassName="sm:my-8 sm:w-full sm:max-w-2xl sm:p-6"
      button={{
        primaryButtonText: "Save",
        secondaryButtonText: "Cancel",
        primaryButtonClassname:
          "px-6 cursor-pointer py-[9px] bg-sky-900 hover:bg-sky-900 rounded-md border border-slate-400 border-opacity-20 justify-center items-center gap-2 flex",
        primaryCallback: handleSave,
        shouldHideOnClick: false,
      }}
      title="PO Delete"
      content={
        <PODeleteModalContent
          onReasonChange={(val) => {
            setReason(val);
            if (val.trim()) setShowError(false);
          }}
          reason={reason}
          showError={showError}
        />
      }
    />
  );
};

export default PODeleteModal;
